/**
 * 화면 행 정렬용 문자열 비교 — 로케일을 **명시**한다(10-15).
 *
 * `a.localeCompare(b)` 처럼 로케일을 비우면 실행 환경의 기본값(서버 Node ICU vs 사용자
 * 브라우저 언어)을 따라 같은 목록이 서버 HTML 과 하이드레이션 결과에서 다른 순서가 될 수 있다.
 * 페이지 로케일로 고정해 서버·브라우저가 같은 순서를 낸다. Collator 는 로케일당 하나만 만든다.
 */
const collators = new Map<string, Intl.Collator>();

function collatorFor(locale: string): Intl.Collator {
  let collator = collators.get(locale);
  if (!collator) {
    try {
      collator = new Intl.Collator(locale);
    } catch {
      // 잘못된 태그 — 고정 로케일로(여전히 환경 기본값에 기대지 않는다)
      collator = new Intl.Collator("en");
    }
    collators.set(locale, collator);
  }
  return collator;
}

/** 페이지 로케일 고정 비교 함수 — `rows.sort((a, b) => cmp(a.name, b.name))`. */
export function textCompare(locale: string): (a: string, b: string) => number {
  return collatorFor(locale).compare;
}
